import { DateTimeHelper } from '../../../../helpers/date-time.helper';
import type { IJourneyCall } from './journey-call.model';

export class JourneyCallApiModel {
  public static mapToBusinessModel(model: JourneyCallApiModel): IJourneyCall {
    return {
      stopPointGid: model.stopPointGid,
      order: model.order,
      plannedArrivalTime: model.plannedArrivalTime === null ? null : DateTimeHelper.parse(model.plannedArrivalTime),
      actualArrivalTime: model.actualArrivalTime === null ? null : DateTimeHelper.parse(model.actualArrivalTime),
      estimatedArrivalTime: model.estimatedArrivalTime === null ? null : DateTimeHelper.parse(model.estimatedArrivalTime),
      plannedDepartureTime: model.plannedDepartureTime ? DateTimeHelper.parse(model.plannedDepartureTime) : null,
      actualDepartureTime: model.actualDepartureTime ? DateTimeHelper.parse(model.actualDepartureTime) : null,
      estimatedDepartureTime: model.estimatedDepartureTime ? DateTimeHelper.parse(model.estimatedDepartureTime) : null,
      passed: model.passed,
      cancelled: model.cancelled,
      locationSignature: model.locationSignature,
      stopAreaName: model.stopAreaName,
    };
  }

  public stopPointGid!: string | null;
  public order!: number;
  public plannedArrivalTime!: string | null;
  public actualArrivalTime!: string | null;
  public estimatedArrivalTime!: string | null;
  public plannedDepartureTime?: string | null;
  public actualDepartureTime?: string | null;
  public estimatedDepartureTime?: string | null;
  public passed!: boolean;
  public cancelled!: boolean;
  public locationSignature!: string | null;
  public stopAreaName!: string | null;
}
